(function () {
  'use strict';

  angular
    .module('app')
    .controller('searchController', searchController);

  searchController.$inject = ['$scope', 'searchService', '$location'];
  function searchController($scope, searchService, $location) {

    /* jshint validthis:true */
    var vm = this;
    vm.init = init;
    vm.searchresults = [];
    vm.noResults = null;
    vm.searchfreetext = searchfreetext;
    vm.closeSearch = closeSearch;
    //vm.getNextResults = getNextResults;
    vm.totalsearchresults = 0;
    vm.query = null;
    vm.viewMoreText = null;
    vm.loading = false;
    vm.showCloseSearch = true;
    //vm.triggerSearch = triggerSearch;
    vm.sortOptions = [
      { key: 'Relevans', value: { 'r': false } },
      { key: 'Namn', value: { 'n': true } }
    ];
    vm.filterModel = {
      sorting: {}
    };
    var filterShortKeys = {
      'sorting': 's',
    };
    function init(q) {

      vm.query = q || '';
      vm.filterModel.sort = vm.sortOptions[0];

      searchfreetext();

      //parseLocationHash();
    }

    function searchfreetext() {
      if (vm.query.length > 2) {
        vm.loading = true;
        searchService.freetextsearch(vm.query, 10, 0).then(function (result) {
          if (result && result.data) {
            vm.searchresults = result.data.searchResults || [];
            vm.totalsearchresults = result.data.totalResults || 0;
            vm.viewMoreText = result.data.viewMoreText;
            vm.noResults = result.data.noResults;
          }
        },
          function (error) {
            console.log(error);
          })
          .then(function () {
            vm.loading = false;
            vm.showCloseSearch = true;
          });
      }
    }

    function closeSearch() {
      var field = $('.mobile-search-container > input');
      field.val('');
      vm.query = '';
      vm.showCloseSearch = false;
    }

    //function getNextResults() {
    //  if ((vm.searchresults || []).length < 10) return;

    //  vm.loading = true;
    //  searchService.freetextsearch(vm.query, 10, vm.searchresults.length).then(function (result) {
    //    if (result && result.data) {
    //      for (var i = 0; i < result.data.searchResults.length; i++) {
    //        vm.searchresults.push(result.data.searchResults[i]);
    //        vm.totalsearchresults = result.data.totalResults;
    //      }
    //      vm.viewMoreText = result.data.viewMoreText;
    //    }
    //  },
    //    function (error) {
    //      console.log(error);
    //    })
    //    .then(function () {
    //      vm.loading = false;
    //    });
    //    }
    //function triggerSearch($event) {
    // if ($event) {
    //  if ($event.keyCode === 13) {
    //   //getResults();
    //            vm.query = $event.currentTarget.value;

    //            searchfreetext();
    //  }
    // }
    //    }
    //   function triggerBootstrapSelectChangeEvent(type) {
    //    console.log("test boootstrap");
    //var text = '';
    //if (type === 'sorting') {
    //       text = vm.filterModel.sort.key;
    //   }
    ////else if (type === 'page-size') {
    //// text = vm.pageSize;
    ////}
    //$('.js-' + type).parents('.bootstrap-select').find('li.selected').removeClass('selected');
    //$('.js-' + type).parents('.bootstrap-select').find('li a span.text:contains("' + text + '")').parents('li').addClass('selected');
    //$('.js-' + type).parents('.bootstrap-select').find('.filter-option').html(text).attr('title', text);
    //   }
  }
})();
